import {
  PREPAIDCARD_STATEMENT_SUCCESS,
  PREPAIDCARD_STATEMENT_FAILED,
  PREPAIDCARD_STATEMENT_INVALID_REQUEST,
  LOADING_PREPAIDCARD_STATEMENT,
  PREPAIDCARD_STATEMENT_NOTFOUND,
  RESET_PREPAIDCARD_STATEMENT
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PREPAIDCARD_STATEMENT:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        data: {}
      };
    case PREPAIDCARD_STATEMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        data: action.payload
      };

    case PREPAIDCARD_STATEMENT_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case PREPAIDCARD_STATEMENT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case PREPAIDCARD_STATEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        data: action.payload
      };

    case RESET_PREPAIDCARD_STATEMENT:
      return (state = initialState);

    default:
      return state;
  }
};
